import React from 'react';
import { useFormContext } from 'ui-builder';

export default function MaxLengthInfo(
  props: {
    name: string,
    value?: string
  }
) {
  const formContext = useFormContext();

  const maxLength = formContext.getConstraintValue
    ? formContext.getConstraintValue(props.name, 'maxLength')
    : undefined;

  if (maxLength) {
        return (
      <span className="input-hint">
          {(props.value || '').length}
        /
        {maxLength}
      </span>
    );
  } else {
    return null;
  }
}
